import React, { useEffect } from 'react'
import { isMobile } from 'react-device-detect'
import { useParams } from 'react-router-dom'
import {
  DcButton,
  DcDropDown,
  PixelFactoryContext,
  PixelFlexBox,
  DcInput,
} from 'pixel-base'

import { updateCourierInfo } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../decl.d'

const EditCourierInfo = (props) => {
  const [couriersCompanies, setCouriersCompanies] = React.useState([])
  const [activeCompany, setActiveCompany] = React.useState<any>(null)
  const [fields, setFields] = React.useState([])

  const params = useParams()
  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const { courierId, courierCompanies, courier, paymentGateways, handleClose } =
    props
  const id = courierId ?? params?.id ?? courier?.courier_id
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  const [data, setData] = React.useState({
    access_type: 1,
    courier_name: '',
    courier_origin_city: '',
    company_id: '',
    payment_gateway_id: '',
    active: 1,
  })

  const fieldName = [
    'Courier Username',
    'Password',
    'Cost Center',
    'API Key',
    'API Token',
    'API Secret',
    'Vendor ID',
    'Shipper Address ID',
    'Account #',
  ]

  const handleSubmit = (e) => {
    e.preventDefault()
    handleUpdateCourier()
  }

  const handleCompanyChange = (e) => {
    setData({ ...data, company_id: e.target.value })
    const company = couriersCompanies.find(
      (company: any) => company.id == e.target.value,
    )
    if (company !== undefined) {
      setActiveCompany(company)
      let allFields = []
      for (const key in company.schema.types) {
        if (company.schema.types[key].length !== 0 && key !== 'series') {
          allFields = allFields.concat(company.schema.types[key])
        }
      }
      setFields(allFields)
    }
  }

  const handleUpdateCourier = () => {
    if (!activeCompany?.id || !id) return
    showPageLoader()
    const postData = { ...data, company_id: activeCompany.id }

    updateCourierInfo(id, postData).subscribe((res: any) => {
      hidePageLoader()
      if (res.response && courier.courier_id) {
        showSuccess('Successfully Updated')
        handleClose(res.response)
      } else {
        if (res.response && res.response.field) {
          setError({
            error: res.response.error ?? '',
            field: res.response.field,
          })
        } else {
          showFailure(res.response)
        }
      }
    })
  }

  const getAllCourierCompanies = () => {
    const companies = courierCompanies
      ?.map((c) => {
        c['slug'] = c.name.replace(/\s+/g, '-').toLowerCase()
        return c
      })
      .filter((c) => {
        return !!c.schema
      })

    setCouriersCompanies(companies ?? [])
    if (companies?.length && courier) {
      getCourierDetails(companies)
    }
  }

  const getCourierDetails = (companies) => {
    const company = findActiveCompany(companies)
    setActiveCompany(company)
    if (!company?.schema?.types) {
      setFields([])
      return
    }
    let allFields = []
    for (const key in company.schema.types) {
      if (company.schema.types[key]?.length !== 0 && key !== 'series') {
        allFields = allFields.concat(company.schema.types[key])
      }
    }
    setFields(allFields)
  }

  const findActiveCompany = (companies) => {
    const company_id = courier.company_id
      ? courier.company_id
      : courier?.courier_company.id
    return companies?.find((company: any) => company.id == company_id)
  }

  useEffect(() => {
    if (!courier) return
    const mappedData = {
      ...courier,
      access_type: courier.courier_type?.courier_type_id ?? courier.access_type,
      password: courier.courier_password ?? courier.password,
      company_id: courier.company_id ?? courier?.courier_company?.id ?? '',
      username: courier.courier_username ?? courier.username,
      origin_city: courier.courier_origin_city ?? courier.origin_city,
    }
    setData(mappedData)
  }, [courier])

  useEffect(() => {
    if (courierCompanies?.length && courier) {
      getAllCourierCompanies()
    }
  }, [courierCompanies, courier])

  return (
    <>
      {activeCompany && (
        <form
          style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
          onSubmit={handleSubmit}
        >
          <PixelFlexBox
            flexWrap="nowrap"
            justifyContent="flex-start"
            gap="10px"
            width="100%"
            style={{
              display: 'inline-flex',
              flexDirection: isMobile && 'column',
              flexGrow: '1',
            }}
            isMobile={isMobile}
          >
            <PixelFlexBox
              flexWrap="nowrap"
              justifyContent="flex-start"
              gap="10px"
              alignItem="flex-start"
              alignContent="flex-start"
              width={isMobile ? '100%' : '378px'}
              style={{
                display: 'flex',
                width: isMobile && 'column',
                flexGrow: '1',
              }}
            >
              <DcDropDown
                isShowLabel={true}
                customLabel={'Company'}
                label={'Company'}
                error={
                  error.field === 'company_id' && error.error !== ''
                    ? error.error
                    : null
                }
                options={[...(courierCompanies ?? [])].map((data) => {
                  return { label: data.name, value: data.id }
                })}
                required
                disabled={true}
                placeholder={'Company'}
                name={'type'}
                value={data.company_id || ''}
                onChange={handleCompanyChange}
              />
            </PixelFlexBox>
            <PixelFlexBox
              flexWrap="nowrap"
              justifyContent="flex-start"
              gap="10px"
              alignItem="flex-start"
              alignContent="flex-start"
              width="100%"
              style={{
                display: 'inline-flex',
                flexDirection: isMobile && 'column',
                flexGrow: '1',
              }}
              isMobile={isMobile}
            >
              <DcInput
                isShowLabel={true}
                customLabel={'Account Name'}
                label={'Account Name'}
                error={
                  error.field === 'courier_name' && error.error !== ''
                    ? error.error
                    : null
                }
                required
                type={'text'}
                name={'Account Name'}
                placeholder={'Account Name'}
                value={data.courier_name || ''}
                onChange={(e) =>
                  setData({ ...data, courier_name: e.target.value })
                }
              />
            </PixelFlexBox>
            <PixelFlexBox
              flexWrap="nowrap"
              justifyContent="flex-start"
              gap="10px"
              alignItem="flex-start"
              alignContent="flex-start"
              width="100%"
              style={{
                display: 'inline-flex',
                flexDirection: isMobile && 'column',
                flexGrow: '1',
              }}
              isMobile={isMobile}
            >
              <DcDropDown
                isShowLabel={true}
                customLabel={'Payment Gateway'}
                label={'Payment Gateway'}
                error={
                  error.field === 'payment_gateway_id' && error.error !== ''
                    ? error.error
                    : null
                }
                required
                placeholder={'Select Payment gateway'}
                options={[
                  {
                    title: 'Select Payment gateway',
                    id: '',
                  },
                  ...(paymentGateways ?? []),
                ].map((p) => {
                  return {
                    label: p.title,
                    value: p.id,
                  }
                })}
                value={data.payment_gateway_id || ''}
                onChange={(e) => {
                  setData({ ...data, payment_gateway_id: e.target.value })
                }}
              />
            </PixelFlexBox>
          </PixelFlexBox>

          {fields
            ?.filter((field) => {
              return fieldName.indexOf(field.field_name) === -1
            })
            ?.map((field, i) => {
              return (
                <PixelFlexBox
                  key={i}
                  flexWrap="nowrap"
                  justifyContent="flex-start"
                  gap="10px"
                  alignItem="flex-start"
                  alignContent="flex-start"
                  width="100%"
                  style={{
                    display: 'inline-flex',
                    flexDirection: isMobile && 'column',
                    flexGrow: '1',
                  }}
                  isMobile={isMobile}
                >
                  <DcInput
                    isShowLabel={true}
                    customLabel={field.field_name}
                    label={field.field_name}
                    error={
                      error.field === field.field && error.error !== ''
                        ? error.error
                        : null
                    }
                    type={field.type}
                    name={field.field}
                    required
                    placeholder={field.field_name}
                    value={data[field.field] || ''}
                    onChange={(e) =>
                      setData({ ...data, [field.field]: e.target.value })
                    }
                  />
                </PixelFlexBox>
              )
            })}
          <PixelFlexBox
            flexWrap="nowrap"
            gap="10px"
            width="100%"
            style={{
              display: 'inline-flex',
              flexDirection: isMobile && 'column',
              flexGrow: '1',
            }}
            justifyContent="flex-end"
            isMobile={isMobile}
          >
            <DcButton type={'submit'}>Save</DcButton>
          </PixelFlexBox>
        </form>
      )}
    </>
  )
}

export default EditCourierInfo
